import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const DesktopHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 14.5h18m-5.949 6s-.945 0-1.085-1.5m-5.017 1.5s.945 0 1.085-1.5M7.5 20.5h9M13.682 6.75A1.82 1.82 0 0 0 12 7.881a1.82 1.82 0 0 0-1.685-1.131 1.99 1.99 0 0 0-1.82 2.009c0 2.2 3.038 3.991 3.505 3.991s3.505-1.79 3.505-3.991a1.99 1.99 0 0 0-1.823-2.009M3.5 4.5h17a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(DesktopHeart) as SvgIcon;
export { ForwardRef as ReactComponent };
